export const domain = 'http://3.123.248.198/anto/'